import { FC } from 'react';
import { useGetAllNotifications } from '../../APIs/notificationsAPI';
import { reformat } from '../../utils/DateUtils';
import { Link } from 'react-router';
import { Icon, Icons } from '../atomic/icons';
import { Loading } from '../atomic/effects';
import { NotificationModel } from '../../models/NotificationModel';
import { NotificationLabel } from './NotificationLabel';

type Prop = {};
export const Notifications: FC<Prop> = () => {
    const { notifications, isLoading } = useGetAllNotifications();

    return (
        <>
            <div className="app-main home page-notifications">
                <h1>お知らせ</h1>
                {isLoading ? (
                    <Loading />
                ) : notifications && notifications.length === 0 ? (
                    <>通知はありません。</>
                ) : (
                    <ul className="notifications">
                        {notifications.map((notification) => (
                            <NotificationRow
                                key={notification.notificationId}
                                notification={notification}
                            />
                        ))}
                    </ul>
                )}
            </div>
        </>
    );
};

const NotificationRow = (props: { notification: NotificationModel }) => {
    const { notification } = props;

    const url = notification.isVisibleLogin
        ? `/app/public/notification/${notification.notificationId}`
        : `/app/notification/${notification.notificationId}`;
    return (
        <li className="notification list-notification">
            <span className={'datetime'}>
                {reformat(notification.updatedAt)}
            </span>
            <NotificationLabel type={notification.notificationType} />
            {notification.content ? (
                <div className={'title'}>
                    <Link key={notification.notificationId} to={url}>
                        {notification.title}
                    </Link>
                    <Icon icon={Icons.Link} />
                </div>
            ) : (
                <div className={'title'}>{notification.title}</div>
            )}
        </li>
    );
};
